import * as actionTypes from '../../actions/actionsTypes'
import { updateObject } from '../../utility'

const initialState = {
    clusterData   : [],
    loading   : false,
    totalCount: 0,
    getListingCluster:[],
    totalCountUser:0
}

const fetchClusterDataStart = (state, action) => {
    return updateObject(state, {
        loading  : action.loading
    })
}

const fetchClusterDataSuccess = (state, action) => {
    return updateObject(state, {
        clusterData : action.payload,
        loading : action.loading,
        totalCount:action.totalCount
    })
}
// store cluter user data by get api
const fetchGetClusterDataSuccess = (state, action) => {
    return updateObject(state, {
        getListingCluster : action.payload,
        loading : action.loadingUser,
        totalCountUser:action.totalCountUser
    })
}
const fetchClusterDataFail = (state, action) => {
    return updateObject(state, {
        loading :action.loading
    })
}

const ClusterLIstingReducer = (state = initialState, action) => {
    switch(action.type){
        case actionTypes.FETCH_CLUSTERLISTING_START   : return fetchClusterDataStart(state, action)
        case actionTypes.FETCH_CLUSTERLISTING_SUCCESS : return fetchClusterDataSuccess(state, action)
        case actionTypes.FETCH_CLUSTERLISTING_FAIL    : return fetchClusterDataFail(state, action)
        case actionTypes.FETCH_CLUSTERLISTINGGET_SUCCESS  :return fetchGetClusterDataSuccess(state,action)
        default                                 : return state
    }
}

export default ClusterLIstingReducer;